import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext';
import { useRefreshingAsync } from './common/commonHooks';

const UserDashboardActionItems = ({ investmentAccountId }) => {
  const { lang } = useLanguage(translations);
  const { api, user, userEmployments } = useAuth();

  const recurringDeposits = useRefreshingAsync(async () => await api.getUserRecurringDeposits(investmentAccountId));

  const hasEmptyBeneficiaries = user && Array.isArray(user?.beneficiaries) && user.beneficiaries.length === 0;

  return (
    recurringDeposits &&
    userEmployments && (
      <>
        {recurringDeposits.length === 0 && userEmployments.length === 0 && (
          <p>{lang('setupRecurringMessageNoEmployment')}</p>
        )}
        {hasEmptyBeneficiaries && <p>{lang('addBeneficiariesMessage')}</p>}
      </>
    )
  );
};

export default UserDashboardActionItems;
